import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { createFooterLinks } from '@usheru-hff/shared/domain';
import { CookieSettingsService } from '@usheru-hff/shared/utils-cookies';

import { NavigationLinks, NAVIGATION_LINKS } from '../navigation';

function navigationLinksFactory(cookieService: CookieSettingsService): NavigationLinks {
  const command = () => {
    cookieService.openDialogOnDemand();
    return true;
  };

  return {
    FOOTER_LINKS: createFooterLinks([
      {
        name: 'cookie-settings',
        url: '/',
        order: 99,
        visibility: 3,
        isPopup: true,
        preventScrollTop: true,
        command
      }
    ])
    // You can add HEADER_LINKS similarly if you want
    // HEADER_LINKS: createHeaderLinks([...]),
  };
}

export function provideCookiePolicyLink(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: NAVIGATION_LINKS,
      useFactory: navigationLinksFactory,
      deps: [CookieSettingsService]
    }
  ]);
}
